export const APP_NAME = 'laboratorio';
